import React, { useState } from "react";
import CustomModal from "../../theme/style-components/CustomModal";
import CustomInput from "../../theme/style-components/CustomInput";
import {
  Box,
  Grid2,
  Link,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import CustomButton from "../../theme/style-components/CustomButton";
import { useFormik } from "formik";
import * as yup from "yup";
import { toast } from "react-toastify";
import { showError } from "../../shared/helperFunction";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import {useLazyGetSharedChartPdfDataQuery } from "../../store/chart/ChartApiSlice";
import { selectCurrentUserObject } from "../../store/auth/authSlice";
import { useSelector } from "react-redux";

const Sharelink = ({
  openDialog,
  shareableLink,
  handleCopyUrl,
  setOpenDialog,
  isButtonDisabled,
  shareChart,
  department_ids =[],
  team_ids=[]
}) => {
  const [link, setLink] = useState("");
  const [hashId, setHashId] = useState("");
  const [isLinkGenerated, setIsLinkGenerated] = useState(false);
  const [activeEmailInput, setActiveEmailInput] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector(selectCurrentUserObject);

  const [getSharedChartPdfData, { data: pdfData, isLoading:isPdfLoading, isError }] = useLazyGetSharedChartPdfDataQuery();

  const validationSchema = yup.object({
    date: yup.date("Please enter the valid date"),
    email: yup.string().email("Please enter a valid email"),
    // .required("please enter the date"),
  });
  const formik = useFormik({
    initialValues: {
      date: "",
      email: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const { date, email } = values;
      if (date) {
        try {
          const response = await shareChart({
            org_id: user?.company,
            department_ids: department_ids,
            team_ids,
            expires_at: new Date(date).toISOString(),
          }).unwrap();
        if(response?.data?.hash_id){
          setHashId(response?.data?.hash_id)
          }
          if (response?.data?.shareable_link) {
            toast.success("link genrated successfully!");
            const URL = response.data.shareable_link.split("/");
            setLink(URL[URL.length - 2]);
            setIsLinkGenerated(true);
            formik.setFieldValue("date", "");
          }
        } catch (err) {
          if (err) {
            showError(err?.data);
          }
        }
      } else {
        setIsLoading(true);
        try {
          const response = await getSharedChartPdfData({
            hash_id: hashId,
            email,
          }).unwrap();
          if (response) {
            toast.success(response.message);
            setOpenDialog(false);
            setIsLoading(false);
          }
        } catch (err) {
          if (err) {
            showError(err?.data);
            setIsLoading(false);
          }
        }
      }
    },
  });

  const handleCopyToClipboard = () => {
    const urlToCopy = `${process.env.REACT_APP_URL}/org_chart/shared/${link}`;
    navigator.clipboard
      .writeText(urlToCopy)
      .then(() => {
        alert("URL copied to clipboard!");
      })
      .catch((err) => {
        toast.error("Failed to copy the URL");
      });
  };

  const handleDateChange = (event) => {
    formik.handleChange(event);
    if (isLinkGenerated) {
      setLink("");
      setIsLinkGenerated(false);
      setActiveEmailInput(false);
    }
  };

  const handleEmailChange = (event) => {
    formik.handleChange(event);
  };

  const handleDownloadPDF = async () => {
    try {
      const response = await getSharedChartPdfData({
        hash_id: hashId,
      }).unwrap();

      const url = window.URL.createObjectURL(response);
      const a = document.createElement("a");
      a.href = url;
      a.download = "OrgChart.pdf";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      toast.success("PDF downloaded successfully!");
      setOpenDialog(false);
    } catch (err) {
      console.error("Error downloading PDF:", err);
      toast.error("Failed to download PDF");
    }
  };

  const handleSharePDF = () => {
    setActiveEmailInput(true);
  };

  return (
    <>
      <CustomModal
        isModalOpen={openDialog}
        isShowActionButton={false}
        maxWidth="sm"
        handleClose={() => setOpenDialog(false)}
      >
        <Grid2
          container
          spacing={4}
          sx={{
            width: "100%",
          }}
        >
          <Grid2 size={8}>
            <CustomInput
              type={"date"}
              id="ShareableLink"
              name="date"
              value={formik.values.date}
              onChange={handleDateChange}
              error={formik.touched.date && Boolean(formik.errors.date)}
              min={new Date().toISOString().split("T")[0]}
            />
          </Grid2>
          <Grid2 size={4}>
            <CustomButton
              color="primary"
              type="submit"
              buttonName="Share URL"
              disabled={!formik.values.date || isLinkGenerated}
              onClick={formik.handleSubmit}
            />
          </Grid2>
        </Grid2>
        <Grid2
          sx={{
            display: link ? "flex" : "none",
            width: "100%",
            marginTop: "12px",
          }}
          container
        >
          <Grid2 size={10}>
            <Box
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "wrap",
                width: "100%",
              }}
            >
              <Link>{`${process.env.REACT_APP_URL}/org_chart/shared/${link}`}</Link>
            </Box>
          </Grid2>
          <Grid2 size={1}>
            <IconButton
              onClick={handleCopyToClipboard}
              color="primary"
              sx={{ padding: 0 }}
            >
              <FileCopyIcon />
            </IconButton>
          </Grid2>
        </Grid2>

        {isLinkGenerated && (
          <Grid2
            container
            spacing={4}
            sx={{
              width: "100%",
              marginTop: "15px",
            }}
          >
            <Grid2 size={8}>
              {activeEmailInput && (
                <CustomInput
                  type={"text"}
                  id="email"
                  name="email"
                  value={formik.values.email}
                  onChange={handleEmailChange}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  placeholder="Enter email address"
                />
              )}
            </Grid2>
            <Grid2 size={4}>
              {activeEmailInput ? (
                <CustomButton
                  color="primary"
                  buttonName="Submit"
                  isLoading={isLoading}
                  onClick={formik.handleSubmit}
                  disabled={isLoading}
                />
              ) : (
                <CustomButton
                  color="primary"
                  buttonName="Share PDF"
                  onClick={handleSharePDF}                  
                />
              )}
            </Grid2>
          </Grid2>
        )}
      </CustomModal>
    </>
  );
};

export default Sharelink;
